import axios from 'axios';
import authHeader from './auth-header';

const API_URL = 'https://guide.msoftit.com/api/'; //Production
// const API_URL = 'http://127.0.0.1:8000/api/'; //Demo

class UserService {

  authPostRequest(url, request, config = {}) {
    const headers = { ...authHeader(), ...(config.headers || {}) };
    return axios.post(API_URL + url, request, { ...config, headers });
  }

  authGetRequest(url, request, config = {}) {
    const headers = { ...authHeader(), ...(config.headers || {}) };
    return axios.get(API_URL + url, { 
      params: request,
      headers,
      ...config
    });
  }

  authDeleteRequest(url, request) {
    return axios.delete(API_URL + url, { 
      data: request,
      headers: authHeader() 
    });
  }

  authPutRequest(url, request) {
    return axios.put(API_URL + url, request, { headers: authHeader() });
  }

  PostRequest(url, request) {
    return axios.post(API_URL + url, request);
  }

    GetRequest(url, request) {
    return axios.get(API_URL + url, { params: request });
  }

  getOtp(url, request) {
    return axios.post(API_URL + url, request);
  }

  verifyOtp(url, request) {
    return axios.post(API_URL + url, request);
  }

  resetPin(url, request) {
    return axios.post(API_URL + url, request, { headers: authHeader() });
  }

  addAdmin(url, request) {
    return axios.post(API_URL + url, request, { headers: authHeader() });
  }

  getAdminList(url, request) {
    return axios.post(API_URL + url, request, { headers: authHeader() });
  }

  getSubLevels(url, request) {
    const requestData = {
      sub_level_type: request.sub_level_type,
      id: request.id,
      lajna:request.lajna
    };
    return axios.post(API_URL + url, requestData, { headers: authHeader() });
  }

  getPublicContent() {
    return axios.get(API_URL + 'all');
  }

  getUserBoard() {
    return axios.get(API_URL + 'user', { headers: authHeader() });
  }

  getModeratorBoard() {
    return axios.get(API_URL + 'mod', { headers: authHeader() });
  }

  getAdminBoard() {
    return axios.get(API_URL + 'admin', { headers: authHeader() });
  }

  getCombobox(request) {
    return axios.post(API_URL + 'get-combobox', request, { headers: authHeader() });
  }

  gotoCourses(request) {
    return axios.post('https://courses.wisdomislam.org/guide', request);
  }

  // Signature upload methods
  uploadSignature(signatureData) {
    const formData = new FormData();
    
    // Convert base64 to blob if needed
    if (signatureData.startsWith('data:image')) {
      const blob = this.dataURLtoBlob(signatureData);
      formData.append('signature', blob, 'signature.png');
    } else {
      formData.append('signature', signatureData);
    }
    
    return this.authPostRequest('upload-signature', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  removeSignature(userId, memberId = null) {
    return this.authPostRequest('remove-signature', {
      user_id: userId,
      member_id: memberId
    });
  }

  // Helper method to convert dataURL to Blob
  dataURLtoBlob(dataURL) {
    const arr = dataURL.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    
    return new Blob([u8arr], { type: mime });
  }

}

export default new UserService();
